import { useHistory } from 'react-router-dom';
import { DEPRESSION } from 'components/shared/types';
import MailingList from 'components/assessment-email';
import { DEPRESSION_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const DepressionEmail = (): JSX.Element => {
  const history = useHistory();
  const data = localStorage.getItem(DEPRESSION_ASSESSMENT_RESULT);

  const handleNextPage = () => {
    history.push('/depression-assessment-result');
  };

  if (!data) {
    history.push('/depression-self-test');
    return <></>;
  }

  return <MailingList handleNextPage={handleNextPage} condition={DEPRESSION} />;
};

export default DepressionEmail;
